

import React, { useState, useEffect, useRef } from "react";
import { StyledDropdown, Toggle, List, ListItem } from "../components/Dropdown/styles";
import i18n from "../i18n";
import { useLocation } from "react-router-dom";
import { t } from "i18next";

export default function LanguageDropdown() {
  const location = useLocation();
  const isLogin = location.pathname === "/login";
  const isNonAuthenticatedPage = ["/login", "/forgot-password", "/reset-password", "/sso-login", "/mfa", "/login/sso/callback", "/select-tenant"].includes(location.pathname);
  const container = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    {
      code: "fr",
      label: isNonAuthenticatedPage ? "FR" : t("DropDownLanguage.FRENCH"),
      flag: "🇫🇷"
    },
    {
      code: "en",
      label: isNonAuthenticatedPage ? "ENG" : t("DropDownLanguage.ENGLISH"),
      flag: "🇺🇸"
    },
  ];

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  const handleClick = () => {
    setIsOpen((o) => !o)
  };

  // For account page, render a simple preferences section
  if (!isNonAuthenticatedPage) {
    return (
      <div className="preferences-simple">
        <div className="preference-section">
          <div className="preference-icon">
            <i className="fas fa-globe"></i>
          </div>
          <div className="preference-content">
            <div className="preference-info">
              <h3>{t('account.preferences.language')}</h3>
              <p>{t('account.preferences.languageDescription')}</p>
            </div>
            <StyledDropdown
              ref={container}
              style={{ margin: "0px", minWidth: 100, borderColor: "#491777", zIndex: 9999 }}
            >
              <button
                type="button"
                onClick={handleClick}
                className="btn btn-outline-fourth shadow-sm"
                aria-expanded={isOpen}
                style={{
                  height: "36px",
                  fontWeight: 500,
                  fontSize: "0.85rem",
                  margin: "0px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  minWidth: "100px",
                  justifyContent: "space-between"
                }}
              >
                <span>{current.label}</span>
                <svg
                  className="dropdown-chevron"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4.5 6L8 9.5L11.5 6" stroke="#491777" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {isOpen && (
                <List
                  style={{
                    minWidth: container.current ? container.current.offsetWidth : undefined,
                    width: container.current ? container.current.offsetWidth : undefined,
                    right: 0,
                    zIndex: 9999,
                    maxHeight: 'none',
                    overflow: 'visible'
                  }}
                >
                  {languages.map((l) => (
                    <ListItem key={l.code}>
                      <button
                        className={l.code === current.code ? 'selected-language' : ''}
                        style={{
                          background: l.code === current.code ? "#f3f0ff" : "transparent",
                          color: l.code === current.code ? "#7c3aed" : "#222",
                          border: "none",
                          width: "100%",
                          textAlign: "left",
                          padding: "8px 16px",
                          cursor: "pointer",
                          transition: "background 0.2s",
                          fontWeight: 600,
                          fontSize: "0.85rem"
                        }}
                        onMouseOver={e => e.currentTarget.style.background = l.code === current.code ? "#f3f0ff" : "#ebebeb"}
                        onMouseOut={e => e.currentTarget.style.background = l.code === current.code ? "#f3f0ff" : "transparent"}
                        onClick={() => {
                          i18n.changeLanguage(l.code);
                          setIsOpen(false);
                          window.open('/', '_blank');
                          window.close();
                        }}
                      >
                        {l.label}
                      </button>
                    </ListItem>
                  ))}
                </List>
              )}
            </StyledDropdown>
          </div>
        </div>
      </div>
    );
  }

  // Original login page dropdown - now used for all non-authenticated pages
  return (
    <StyledDropdown
      ref={container}
      style={{
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 1000
      }}
    >
      <Toggle
        onClick={handleClick}
        isOpen={isOpen}
        color="#7c3aed"
        style={{
          background: "#fff",
          border: "1px solid #e1e4e8",
          borderRadius: 8,
          padding: "8px 16px",
          boxShadow: "0 0 5px rgba(0,0,0,0.10)",
          color: "#7c3aed",
          fontWeight: 600,
          fontSize: "0.85rem",
          margin: 0
        }}
      >
        <span style={{ display: "flex", alignItems: "center", marginRight: 6 }}>
          <svg className="i18n-switcher__icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" style={{ fill: "#7c3aed" }}>
            <g fill="#7c3aed" fillRule="nonzero">
              <path d="M15.286 20.147a.4.4 0 0 0-.436-.132 7.949 7.949 0 0 1-5.938-.425.2.2 0 0 1-.112-.18v-.92a2 2 0 0 1 .714-1.53A3.6 3.6 0 0 0 7.2 10.6H4.867a.2.2 0 0 1-.193-.251 7.986 7.986 0 0 1 11.637-4.923.2.2 0 0 1-.097.374H14.2a2.2 2.2 0 0 0 0 4.4c.269 0 .535.055.782.16a.4.4 0 0 0 .36-.026 5.174 5.174 0 0 1 5.778.314.4.4 0 0 0 .631-.409A9.6 9.6 0 1 0 8.673 21.247l.127.063v-.016c2.189.892 4.63.94 6.853.136a.4.4 0 0 0 .167-.636c-.17-.198-.349-.415-.534-.647z" />
              <path d="M18 10.8a4.005 4.005 0 0 0-4 4c0 2.537 3.566 6.131 3.718 6.283a.4.4 0 0 0 .565 0C18.435 20.931 22 17.337 22 14.8a4.005 4.005 0 0 0-4-4zm0 5.4a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8z" />
            </g>
          </svg>
        </span>
        <span>{current.label}</span>
      </Toggle>
      {isOpen && (
        <List
          style={{
            minWidth: container.current ? container.current.offsetWidth : undefined,
            width: container.current ? container.current.offsetWidth : undefined,
            right: 0,
            zIndex: 9999
          }}
        >
          {languages.map((l) => (
            <ListItem key={l.code}>
              <button
                className={l.code === current.code ? 'selected-language' : ''}
                style={{
                  background: l.code === current.code ? "#f3f0ff" : "transparent",
                  color: l.code === current.code ? "#7c3aed" : "#222",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                  padding: "8px 16px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                  fontWeight: 600,
                  fontSize: "0.85rem"
                }}
                onMouseOver={e => e.currentTarget.style.background = l.code === current.code ? "#f3f0ff" : "#ebebeb"}
                onMouseOut={e => e.currentTarget.style.background = l.code === current.code ? "#f3f0ff" : "transparent"}
                onClick={() => {
                  i18n.changeLanguage(l.code);
                  setIsOpen(false);
                  window.open('/', '_blank');
                  window.close();
                }}
              >
                {l.label}
              </button>
            </ListItem>
          ))}
        </List>
      )}
    </StyledDropdown>
  );
}
